<template>
  <ul class="list-group" :class="{ scroll: scrollOn }">
    <li class="list-group-item bg-success text-light">
      For account: {{ account }}
    </li>
    <li
      class="list-group-item pointer"
      :class="{ selected: numberSelected === number }"
      v-for="number in numbers"
      :key="number"
      :id="number"
      @click="updateNumber(number)"
    >
      {{ number }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    numbers: {
      type: Array,
      default: () => [],
    },
    account: {
      type: String,
      required: true,
    },
  },

  methods: {
    updateNumber(num) {
      this.numberSelected = num;
      this.$emit("numberUpdated", num);
    },
  },
  data() {
    return {
      numberSelected: null,
    };
  },
  computed: {
    scrollOn() {
      return this.numbers.length > 4;
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.selected {
  background-color: rgb(85 188 201);
  color: whitesmoke;
}
.scroll {
  height: 225px;
  overflow: auto;
}
</style>
